var map = {
	"./diagnostico-1-avatar.mp4": 7632,
	"./diagnostico-1-manuel.mp4": 2200,
	"./silent-video-manuel.mp4": 978,
	"./silent-video.mp4": 8511,
	"./start-chime.mp4": 9495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;